// Deliberately its own query param, separate from ?debug=1 (the existing
// simulated-data escape hatch several game controllers read in their own
// mount() - see e.g. games/shared/x01-game-controller.js's own
// `simulateRandomData` line) - that flag short-circuits a whole match into
// instant synthetic data before any CPU player ever actually throws, so it
// can never coincide with a real, animated CPU turn for this to show
// anything on. ?debugAim=1 instead plays out completely normally - CPU
// players included - just with components/cpu-dartboard-overlay.js also
// marking where each dart was actually aimed before it lands.
export function isAimDebugMode() {
    return !!new URLSearchParams(window.location.search).get('debugAim');
}

// ?cpuDelay=<ms> overrides the pause between every step of a CPU turn (see
// components/cpu-dartboard-overlay.js's AI_THROW_PAUSE_MS) - ?cpuDelay=0
// removes the delays entirely, for fast testing. Returns null when absent or
// invalid, so the caller falls back to its own default.
export function cpuDelayOverride() {
    const raw = new URLSearchParams(window.location.search).get('cpuDelay');
    if (raw === null || raw.trim() === '') return null;
    const ms = Number(raw);
    return Number.isFinite(ms) && ms >= 0 ? ms : null;
}
